module.exports = __webpack_public_path__ + "img/service.71c14e3d.png";